import { render, staticRenderFns } from "./ProductosCM.vue?vue&type=template&id=1bb9d078&"
import script from "./ProductosCM.vue?vue&type=script&lang=js&"
export * from "./ProductosCM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports